module.exports = __webpack_public_path__ + "img/calendar-solid-light.18bafcf6.svg";